import React, { useState, useEffect, useContext } from "react";
import { getDownloadURL, getStorage, ref, uploadString } from "firebase/storage";

const StorageContext = React.createContext();
export function useStorage() {
	return useContext(StorageContext);
}

export function StorageProvider({ children }) {
	const [storage, setStorage] = useState();

	useEffect(() => {
		setStorage(getStorage());
	}, []);

	function uploadFSMImage(image, name) {
		const imagesRef = ref(storage, "fsm-images/" + name);
		return uploadString(imagesRef, image, "data_url");
	}
	function getFSMImage(name) {
		const imagesRef = ref(storage, "fsm-images/" + name);
		return getDownloadURL(imagesRef);
	}

	const value = { uploadFSMImage, getFSMImage };
	return (
		<StorageContext.Provider value={value}>
			{children}
		</StorageContext.Provider>
	);
}
